import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Card,
  Grid,
  TextField,
  Typography,
  FormHelperText,
  Autocomplete,
  Stack,
  Badge,
  CircularProgress,
  InputAdornment,
  Divider,
  Button,
  IconButton,
  Switch,
  Icon,
} from "@mui/material";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import { fetchCategories, openSnackbar, uploadImage } from "../../redux/slices/common";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/system";
import {
  createWebCategory,
  deleteWebCategory,
  fetchWebCategories,
} from "../../redux/slices/category";
import { useNavigate, useParams } from "react-router";
import { isEmptyObject } from "utilities/common";
import { webCategoriesValidation } from "../../validations/category";
import defaultImage from "assets/images/placeholder-image.png";
import {
  closeCustomModalDialog,
  openCustomModalDialog,
  setModalLoader,
} from "../../redux/slices/modalSlice";
import CommonQuillEditor from "common/editor";
import { grey } from "@mui/material/colors";
import { AccountCircle, RemoveCircle } from "@mui/icons-material";
import { slugRegex } from "utilities/common";
import { STILO, HYPERWOLF } from "utilities/constants";
import { getData } from "utilities/common";
import AltImageSection from "layouts/strains/addStrain/component/ImageUpdate";
import AngleRightIcon from "common/customIcons/angle_right";
import DeleteIcon from "common/customIcons/delete";

const initialState = {
  webCategoryName: '',
  status: 'active',
  image: '',
  bannerImage: '',
  metaTitle: '',
  metaDescription: '',
  bannerHeading: "",
  heading: '',
  createdBy: '',
  adminCategories: [],
  bottomText: "",
  faq: [],
  webCategoryHeading: "",
  webMenuName: "",
  bannerMobileImage: "",
};
const AddWebCategoryForm = () => {
  const { user } = useSelector((state) => state.auth);
  const [formData, setFormData] = useState({ ...initialState, createdBy: user?.name || "" });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { webCategoryId = "" } = useParams();
  const {
    singleWebCategory = {},
    webCategoriesList = {},
    isCreating = false,
    loading = false,
  } = useSelector((state) => state.category);
  const { categoriesData = [], isUploading = false } = useSelector((state) => state.common);
  const uploadedImageRef = useRef();
  const [productSlugData, setProductSlugData] = useState("");
  const [isProductSlug, setIsProductSlugData] = useState(false);
  const [errors, setErrors] = useState({});
  const adminsMode = getData("adminsMode");
  const isStilo = JSON.parse(adminsMode) === STILO;
  const isHyperwolf = JSON.parse(adminsMode) === HYPERWOLF;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const isQuillContentEmpty = (html = "") => {
    const text = html
      .replace(/<(.|\n)*?>/g, "") // remove tags
      .replace(/&nbsp;/g, "")
      .trim();

    return text.length === 0;
  };


  const productImageUploadHandler = async (e, imageType) => {
    uploadedImageRef.current = imageType;
    if (e.target.files.length) {
      const file = e.target.files[0];

      const body = new FormData();
      body.append("filePath", file);
      // res.fileUrl
      dispatch(uploadImage(body))
        .unwrap()
        .then((res) => {
          uploadedImageRef.current = null;
          if (isHyperwolf) {
            openSeoImageModal(imageType, file, res.fileUrl);
          } else {
            setFormData((prev) => ({
              ...prev,
              [imageType]: res.fileUrl,
            }));
          }
        });
    }
  };

  const onSubmit = (submitStatus = formData.status) => {
    const finalFormData = {
      ...formData,
      status: submitStatus,
      faq: formData.faq?.filter(
        (f) => !isQuillContentEmpty(f?.question) || !isQuillContentEmpty(f?.answer)
      ),
    };
    if (submitStatus !== "draft") {
      const { isValid, errors } = webCategoriesValidation({ ...formData, isStilo });
      if (!isValid) {
        setErrors(errors);
        return;
      }
    }

    let payload = {
      ...finalFormData,
      webCategorySlug: productSlugData,
    };
    if (isProductSlug) {
      payload.webCategorySlug = productSlugData;
    } else {
      delete payload.webCategorySlug;
    }
    // delete payload.webCategorySlugArray;
    delete payload.canonical;
    setErrors({});
    dispatch(createWebCategory(payload))
      .unwrap()
      .then((res) => {
        showError(res?.message, "success");
        navigate("/categories?filter=manage_categories");
      })
      .catch((err) => {
        showError(err?.message, "error");
      });
  };

  const showError = (message, errortype) => {
    if (errortype === "success") {
      dispatch(openSnackbar({ content: message, color: "success", icon: "check" }));
    }
    if (errortype === "error") {
      dispatch(openSnackbar({ content: message, color: "error", icon: "warning" }));
    }
  };

  const deleteHandler = (webCategoryId) => {
    dispatch(setModalLoader(true));
    dispatch(deleteWebCategory(webCategoryId))
      .unwrap()
      .then((res) => {
        showError(res?.message, "success");
        dispatch(closeCustomModalDialog());
        navigate("/categories?filter=manage_categories");
      })
      .catch((err) => {
        dispatch(setModalLoader(false));
        showError(err?.message, "error");
      });
  };

  // const subCatOptions = useMemo(() => {
  //   let newCategories = categoriesData?.categories || [];
  //   if (categoriesData?.categories && webCategoriesList?.values?.length > 0 && webCategoryId) {
  //     newCategories =
  //       categoriesData?.categories?.filter((category) =>
  //         singleWebCategory.adminCategories?.every(
  //           (usedCat) => usedCat.categoryId !== category?.categoryId
  //         )
  //       ) || categoriesData?.categories;
  //   }
  //   return newCategories;
  // }, [categoriesData?.categories, webCategoriesList, formData?.adminCategories]);

  const subCatOptions = useMemo(() => {
    const allCategories = categoriesData?.categories || [];
    const selectedIds =
      formData?.adminCategories?.map((cat) => cat.categoryId) || [];

    return allCategories.filter(
      (category) => !selectedIds.includes(category.categoryId)
    );
  }, [categoriesData?.categories, formData?.adminCategories]);


  useEffect(() => {
    dispatch(fetchWebCategories({ limit: 100, userType: "admin", skip: 0, searchTerm: "" }));
  }, []);

  useEffect(() => {
    if (!isEmptyObject(singleWebCategory)) {
      if (singleWebCategory?.webCategorySlug) {
        setProductSlugData(singleWebCategory?.webCategorySlug);
      }
      setFormData({ ...formData, ...singleWebCategory });
    }
  }, [singleWebCategory]);

  const uploadThumbnailImage = {
    borderRadius: "20px",
    width: "160px",
    height: "160px",
    objectFit: "cover",
    boxShadow: "0 0 1px rgb(0 0 0 / 20%)",
  };
  const badgeCircularProgressIcon = {
    backgroundColor: "#fff",
    borderRadius: 10,
    p: 0.5,
    mr: 14,
    mt: 14,
  };

  const handleChangeFAQ = (value, fieldType, idx) => {
    let FAQArray = [...formData?.faq];
    let faqItem = FAQArray?.find((faq, _idx) => _idx === idx);
    if (faqItem) {
      const faqItemIdx = FAQArray.indexOf(faqItem);
      faqItem = {
        ...faqItem,
        [fieldType]: value,
      };
      FAQArray[faqItemIdx] = faqItem;
      setFormData({ ...formData, faq: FAQArray });
    }
  };


  const addFAQHandler = () => {
    let newFAQ = [...formData?.faq];
    let faqItem = {
      question: "",
      answer: "",
    };
    newFAQ = [...newFAQ, faqItem];
    setFormData({ ...formData, faq: newFAQ });
  };

  const handleRemoveFAQ = (faQIdx) => {
    let FAQArray = [...formData?.faq];
    FAQArray = FAQArray?.filter((faq, _idx) => _idx !== faQIdx);
    setFormData({ ...formData, faq: FAQArray });
  };

  useEffect(() => {
    setFormData({ ...formData, createdBy: user?.name });
  }, [user]);

  useEffect(() => {
    dispatch(fetchCategories({ limit: 1000, skip: 0 }));
  }, []);
  const handleChangeSlug = (e) => {
    const value = e.target.value;
    setIsProductSlugData(true);
    setProductSlugData(slugRegex(value));
  };
  const getImageSrc = (image, fallback = defaultImage) => {
    if (!image) return fallback;
    if (typeof image === "string") return image;
    if (typeof image === "object") return image.url || fallback;
    return fallback;
  };

  const openSeoImageModal = (fieldName, file, imageUrl) => {
    const data = {
      url: imageUrl,
      title: file.name,
      alt: "",
      description: "",
    };

    dispatch(
      openCustomModalDialog({
        modal: "IMAGE_MODAL_SEO",
        modalData: {
          imageContent: fieldName,
          data,
          fileMediaHandler: (mediaData, imageContent) => {
            setFormData((prev) => ({
              ...prev,
              [imageContent]: mediaData,
            }));
          },
        },
      })
    );
  };
  const hasBannerImage = isHyperwolf
    ? !!(
      (typeof formData?.bannerImage?.url === "string" &&
        formData.bannerImage.url.trim()) ||
      (typeof formData?.bannerImage === "string" &&
        formData.bannerImage.trim())
    )
    : !!formData?.bannerImage;

  return (
    <Box p={{ xs: 2, sm: 3, lg: 4 }}>
      <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: "none" }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ sm: "center" }}
          justifyContent="space-between"
          gap={2}
          mb={4.5}
        >
          <span style={{ display: "flex", alignItems: "center" }}>
            <span
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                marginRight: "10px",
              }}
              onClick={() => {
                navigate(-1);
              }}
            >
              <AngleRightIcon fontSize="14px" />
            </span>
            {isStilo ? (
              <Typography variant="h6" fontWeight="semibold">
                {webCategoryId
                  ? `Update Category: ${singleWebCategory?.webCategoryName}`
                  : "Add New Category"}
              </Typography>
            ) : (
              <Typography variant="h6" fontWeight="semibold">
                {webCategoryId ? "Update Web Category " : "Add Web Category "}{" "}
              </Typography>
            )}
          </span>
          <Box display="flex" alignItems="center" gap={1.25}>
            <Typography variant="h5" fontWeight="semibold" color="secondary">
              Status
            </Typography>
            <Stack
              direction="row"
              alignItems="center"
              gap={0.75}
              lineHeight={1}
              p={0.75}
              borderRadius={2}
              bgcolor="#F2F3F7"
            >
              <MDButton
                sx={{
                  minWidth: "92px",
                  borderRadius: 1.75,
                  minHeight: "28px",
                  p: 0.25,
                  fontWeight: 500,
                }}
                type="button"
                variant={formData?.status === "active" ? "contained" : "text"}
                color={formData?.status === "active" ? "success" : "dark"}
                size="small"
                onClick={() => setFormData({ ...formData, status: "active" })}
              >
                Active
              </MDButton>
              <MDButton
                sx={{
                  minWidth: "92px",
                  borderRadius: 1.75,
                  minHeight: "28px",
                  p: 0.25,
                  fontWeight: 500,
                }}
                type="button"
                variant={formData?.status !== "active" ? "contained" : "text"}
                color={formData?.status !== "active" ? "error" : "dark"}
                size="small"
                onClick={() => setFormData({ ...formData, status: "inactive" })}
              >
                Inactive
              </MDButton>
            </Stack>
          </Box>
        </Stack>

        <Typography variant='body2' fontWeight='semibold' mb={1} color="#2E2E3A">
          {isStilo ? "Navigation Icon*" : "Web Category Image"}
        </Typography>
        <Stack direction="row" alignItems="center" flexWrap="wrap" gap={1.25} mb={4.5}>
          <Badge
            overlap="circular"
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            badgeContent={
              isUploading && uploadedImageRef.current === "image" ? (
                <CircularProgress size={32} color="primary" sx={badgeCircularProgressIcon} />
              ) : (
                ""
              )
            }
          >
            <img
              style={{
                backgroundColor: `${isStilo && formData?.image ? "#000000" : ""}`,
                ...uploadThumbnailImage,
              }}
              onClick={() => {
                if (!isHyperwolf || !formData?.image?.url) return;
                dispatch(
                  openCustomModalDialog({
                    modal: "IMAGE_MODAL_SEO",
                    modalData: {
                      imageContent: "image",
                      data: formData.image,
                      fileMediaHandler: (mediaData) => {
                        setFormData((prev) => ({ ...prev, image: mediaData }));
                      },
                    },
                  })
                );
              }}
              src={
                // formData?.image || defaultImage
                // isHyperwolf ? formData?.image?.url || defaultImage : formData?.image || defaultImage
                getImageSrc(formData?.image)
              }
              alt="documentId"
            />
          </Badge>
          <label htmlFor="image-input">
            <MDButton
              onClick={() => {
                if (!isHyperwolf || !formData?.image) return;

                dispatch(
                  openCustomModalDialog({
                    modal: "IMAGE_MODAL_SEO",
                    modalData: {
                      imageContent: "image",
                      data: formData.image,
                      fileMediaHandler: (mediaData) => {
                        setFormData((prev) => ({ ...prev, image: mediaData }));
                      },
                    },
                  })
                );
              }}
              sx={{ minWidth: "180px" }}
              type="button"
              variant="outlined"
              color="secondary"
              component="span"
              disabled={isUploading}
            >
              {formData?.image
                ? isStilo
                  ? "Change Icon"
                  : "Change Image"
                : isStilo
                  ? "Add Icon"
                  : "Add Image"}
            </MDButton>
          </label>
          <MDInput
            id="image-input"
            type="file"
            name="image"
            onChange={(e) => productImageUploadHandler(e, "image")}
            fullWidth
            disabled={isUploading}
            style={{ display: "none" }}
          />
          {Boolean(errors?.image) && (
            <FormHelperText sx={{ width: "100%", ml: 0, mt: -0.5 }} error>
              {errors?.image}
            </FormHelperText>
          )}
        </Stack>

        {isStilo ? (
          <AltImageSection
            errors={errors}
            formData={formData}
            setFormData={setFormData}
            fieldName={"bannerImage"}
            fieldNameMobile={"bannerMobileImage"}
            isbannerImageMobile={true}
            ratioDesktop={isStilo ? "(Size: 1680x300)" : "(Size: 1392x260)"}
          />
        ) : (
          <>
            <Typography variant='body2' fontWeight='medium' mb={1} color="#2E2E3A">
              Banner Image (Size: 1392x260)
            </Typography>
            <Stack direction="row" alignItems="center" flexWrap="wrap" gap={1.25} mb={4.5}>
              <Badge
                overlap="circular"
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                badgeContent={
                  isUploading && uploadedImageRef.current === "bannerImage" ? (
                    <CircularProgress size={32} color="primary" sx={badgeCircularProgressIcon} />
                  ) : (
                    ""
                  )
                }
              >
                <img
                  style={uploadThumbnailImage}
                  src={
                    // formData?.bannerImage || defaultImage
                    // isHyperwolf ? formData?.bannerImage?.url || defaultImage : formData?.bannerImage || defaultImage
                    getImageSrc(formData?.bannerImage)
                  }
                  onClick={() => {
                    if (!isHyperwolf || !formData?.bannerImage?.url) return;
                    dispatch(
                      openCustomModalDialog({
                        modal: "IMAGE_MODAL_SEO",
                        modalData: {
                          imageContent: "image",
                          data: formData.bannerImage,
                          fileMediaHandler: (mediaData) => {
                            setFormData((prev) => ({ ...prev, bannerImage: mediaData }));
                          },
                        },
                      })
                    );
                  }}

                  alt="documentId"
                />
              </Badge>
              <label htmlFor="bannerImage-input">
                <MDButton
                  sx={{ minWidth: "180px" }}
                  type="button"
                  variant="outlined"
                  color="secondary"
                  component="span"
                  disabled={isUploading}
                >
                  {/* {formData?.bannerImage ? "Change Image" : "Add Image"} */}
                  {hasBannerImage ? 'Change Image' : 'Add Image'}
                </MDButton>
              </label>
              <MDInput
                id="bannerImage-input"
                type="file"
                name="bannerImage"
                onChange={(e) => productImageUploadHandler(e, "bannerImage")}
                fullWidth
                disabled={isUploading}
                style={{ display: "none" }}
              />
              {Boolean(errors?.bannerImage) && (
                <FormHelperText sx={{ width: "100%", ml: 0, mt: -0.5 }} error>
                  {errors?.bannerImage}
                </FormHelperText>
              )}
            </Stack>
          </>
        )}
      </Card>

      <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: "none" }}>
        <Typography variant="h5" fontWeight="semibold" mb={4}>
          Category Info
        </Typography>
        <Grid container spacing={2.5}>
          <Grid item xs={12} sm={6} lg={4}>
            <TextField
              label="Category Name*"
              value={formData.webCategoryName}
              fullWidth
              variant="outlined"
              onChange={handleInputChange}
              name="webCategoryName"
              error={Boolean(errors?.webCategoryName)}
              helperText={errors?.webCategoryName}
            />
          </Grid>
          {/*  new add */}
          <Grid item xs={12} sm={4}>
            <TextField
              label="Category Menu Name"
              value={formData.webMenuName}
              fullWidth
              variant="outlined"
              onChange={handleInputChange}
              name="webMenuName"
              className="form-input"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Category Heading (H1)"
              value={formData.webCategoryHeading}
              fullWidth
              variant="outlined"
              onChange={handleInputChange}
              name="webCategoryHeading"
              className="form-input"
            />
          </Grid>
          {(webCategoryId || isStilo) && (
            <Grid item xs={12}>
              <TextField
                className="form-input"
                fullWidth
                label="Web Category Slug"
                name="webCategorySlug"
                value={productSlugData}
                onChange={handleChangeSlug}
              />
            </Grid>)}
          {isStilo && (
            <Grid item xs={12}>
              <TextField
                label="Banner Heading"
                name="bannerHeading"
                fullWidth
                value={formData.bannerHeading}
                onChange={handleInputChange}
              />
            </Grid>
          )}
          {
            !isStilo &&
            <Grid item xs={12}>
              <Typography variant='body2' fontWeight='medium' mb={1} color="#2E2E3A">
                Description*
              </Typography>
              <CommonQuillEditor
                value={formData?.description || ""}
                allowHeading={false}
                onChange={(value) => setFormData({ ...formData, description: value })}
              />
              {Boolean(errors?.description) && (
                <FormHelperText error>{errors?.description}</FormHelperText>
              )}
            </Grid>
          }
          <Grid item xs={12}>
            <Typography variant='body2' fontWeight='medium' mb={1} color="#2E2E3A">
              {isStilo ? "Body Text" : "Bottom Text"}
            </Typography>
            <CommonQuillEditor
              allowHeading={false}
              style={true}
              height={"300px"}
              value={formData?.bottomText || ""}
              onChange={(value) => setFormData({ ...formData, bottomText: value })}
            />
            {Boolean(errors?.bottomText) && (
              <FormHelperText error>{errors?.bottomText}</FormHelperText>
            )}
          </Grid>
        </Grid>
      </Card>

      <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: "none" }}>
        <Grid container spacing={2.5}>
          <Grid item xs={12}>
            <Typography variant="h5" fontWeight="semibold" mb={4}>
              FAQ&apos;s
            </Typography>
            {formData?.faq?.length > 0 ? (
              <>
                {formData?.faq?.map((faq, idx) => {
                  return (
                    <Grid key={idx} item xs={12} sm={12} lg={12} my={2}>
                      <Box width={"100%"} className="faq-sec-rep">
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="space-between"
                          alignItems={"flex-start"}
                          className="mb-3"
                        >
                          <Box
                            width={"100%"}
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            mb={1}
                          >
                            <Typography variant="body2" fontWeight="medium" color="#2E2E3A">
                              Question
                            </Typography>
                            <IconButton 
                              onClick={() => handleRemoveFAQ(idx)}
                              style={{ color: "#fd4438" }}
                            >
                              <DeleteIcon width="16px" height="16px" />
                            </IconButton>
                          </Box>
                          <Box width={"100%"}>
                            <CommonQuillEditor
                              allowImage={false}
                              allowHeading={false}
                              value={faq?.question || ""}
                              onChange={(value) => handleChangeFAQ(value, "question", idx)}
                            />
                          </Box>
                        </Box>

                        <Box display="flex" justifyContent="center" alignItems={"flex-start"}>
                          <Box width={"100%"}>
                            <Typography
                              variant="body2"
                              fontWeight="medium"
                              color="#2E2E3A"
                              mb={1}
                            >
                              Answer
                            </Typography>
                            <CommonQuillEditor
                              allowImage={false}
                              allowHeading={false}
                              value={faq?.answer || ""}
                              onChange={(value) => handleChangeFAQ(value, "answer", idx)}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                  );
                })}
              </>
            ) : (
              <Grid item xs={12} sm={12} lg={12} mt={3}>
                <Box display="flex" justifyContent="space-between" alignItems={"center"}>
                  <MDButton
                    type="button"
                    color="primary"
                    size="medium"
                    variant="outlined"
                    sx={{ minWidth: "180px" }}
                    onClick={addFAQHandler}
                  >
                    <Icon>add</Icon>&nbsp;Add FAQ
                  </MDButton>
                </Box>
              </Grid>
            )}
            
            
            {/* {
              formData?.faq?.length > 0 && 
              <Grid container>
              <Grid item xs={12} mt={3}>
                <MDButton
                  type='button'
                  color='primary'
                  size='medium'
                  variant='outlined'
                  sx={{ minWidth: '180px' }}
                  onClick={addFAQHandler}
                >
                  <Icon>add</Icon>&nbsp;Add More
                </MDButton>
              </Grid>
              </Grid>
            } */}

            <Grid container>
              {formData?.faq?.length > 0 && (
                <Grid item xs={12} mt={3}>
                  <MDButton
                    type="button"
                    color="primary"
                    size="medium"
                    variant="outlined"
                    sx={{ minWidth: "180px" }}
                    onClick={addFAQHandler}
                  >
                    <Icon>add</Icon>&nbsp;Add More
                  </MDButton>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Card>

      <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: "none" }}>
        <Typography variant="h5" fontWeight="semibold" mb={4}>
          Sub Category Info
        </Typography>
        <Grid container spacing={2.5}>
          <Grid item xs={12}>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={
                subCatOptions?.length > 0
                  ? subCatOptions?.filter((subcat) => subcat?.status === "active")
                  : []
              }
              getOptionLabel={(option) => option.categoryName}
              filterSelectedOptions
              onChange={(val, selectedOption) => {
                setFormData({ ...formData, adminCategories: selectedOption });
              }}
              value={formData?.adminCategories}
              renderInput={(params) => (
                <TextField
                  {...params}
                  error={Boolean(errors?.adminCategories)}
                  helperText={errors?.adminCategories}
                  label="Sub Categories"
                  placeholder="Categories"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <TextField
              label="Meta Title*"
              value={formData.metaTitle}
              fullWidth
              variant="outlined"
              onChange={handleInputChange}
              name="metaTitle"
              error={Boolean(errors?.metaTitle)}
              helperText={errors?.metaTitle}
            />
            <span className="drag_drop">
              Character Count: {formData?.metaTitle?.length || 0}{" "}
              <span>(Recommended Characters: 60)</span>
            </span>
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <TextField
              className="form-input created-by"
              label="Created By"
              value={formData.createdBy}
              fullWidth
              disabled
              variant="outlined"
              onChange={handleInputChange}
              name="createdBy"
              error={Boolean(errors?.createdBy)}
              helperText={errors?.createdBy}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircle fontSize="medium" color="secondary" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Meta Description*"
              value={formData.metaDescription}
              fullWidth
              variant="outlined"
              onChange={(e) => setFormData({ ...formData, metaDescription: e.target.value })}
              name="metaDescription"
              error={Boolean(errors?.metaDescription)}
              helperText={errors?.metaDescription}
            />
            <span className="drag_drop">
              Character Count: {formData?.metaDescription?.length || 0}{" "}
              <span>(Recommended Characters: 160)</span>
            </span>
            {/* <CommonQuillEditor
              allowHeading={false}
              value={formData?.metaDescription || ''}
              onChange={(value) => setFormData({ ...formData, metaDescription: value })}
            /> */}
            {/* {Boolean(errors?.metaDescription) && <FormHelperText error>{errors?.metaDescription}</FormHelperText>} */}
          </Grid>
        </Grid>
      </Card>

      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} mt={3}>
        <MDButton
          sx={{ minWidth: "160px" }}
          type="button"
          variant="contained"
          color="primary"
          disabled={isUploading || loading || isCreating}
          onClick={() => onSubmit()}
          loading={isCreating || loading}
        >
          {webCategoryId ? "Update" : " Save"}
        </MDButton>

        {webCategoryId && !isHyperwolf && (
          <MDButton
            sx={{ minWidth: "160px", backgroundColor: "#fdd5d3", color: "#FD4438" }}
            type="button"
            variant="contained"
            color="error"
            onClick={() =>
              dispatch(
                openCustomModalDialog({
                  modalData: { deleteHandler, deleteId: webCategoryId },
                  modal: "DELETE_MODAL",
                })
              )
            }
          >
            Delete
          </MDButton>
        )}

        {/* <MDButton */}
        {/* sx={{ minWidth: "140px", backgroundColor: "#fdd5d3", color: "#FD4438" }}
          type="button"
          variant="contained"
          color="error"
          // disabled={isUploading || loading || isCreating}
          onClick={() => onSubmit("draft")}
        // loading={isCreating || loading}
        > */}
        {/* {webCategoryId ? "Update" : " Save"} */}
        {/* Save as draft */}
        {/* </MDButton> */}

        <MDButton
          sx={{ minWidth: "160px" }}
          type="button"
          variant="outlined"
          color="dark"
          onClick={() => navigate("/categories?filter=manage_categories")}
        >
          Cancel
        </MDButton>
      </Stack>
    </Box>
  );
};

export default AddWebCategoryForm;
